import { debug } from "@sitecore-jss/sitecore-jss-nextjs";
import { SearchParams, SearchParamsConfig } from "../../types/search-types";
import * as plugins from "./plugins";

export interface Plugin {
  /**
   * A function that will be called during search params extraction
   * @param segment 
   * @param searchParams 
   */
  exec(segment: string, searchParams: SearchParams, config: SearchParamsConfig): Promise<SearchParams>;
}

export class ParamsResolver {
  /**
   * Extract search parameters from an array of url segments
   * @param segments 
   * @param searchParams 
   * @returns Promise<SearchParams>
   */
  public async extract(
    requestPath: string[],
    searchParams: SearchParams,
    config: SearchParamsConfig,
  ): Promise<SearchParams> {
    const startTimestamp = Date.now();
    debug.common("search-params-resolver start");

    requestPath.forEach(async (segment) => {
      await (Object.values(plugins) as Plugin[]).reduce(
        async (result, plugin) => {
          const params = await result;
          const newParams = await plugin.exec(segment, params, config);
          return newParams;
        },
        Promise.resolve(searchParams)
      );
    });

    debug.common("search-params-resolver end in %dms", Date.now() - startTimestamp);

    return searchParams;
  }
}

export const paramsResolver = new ParamsResolver();
